import React from 'react';

import PropTypes from 'prop-types';

export default function PlusIconNarrow({ color = 'currentColor', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      {...rest}
    >
      <path
        d="M10 5C10 5.05766 9.9771 5.11295 9.93633 5.15372C9.89556 5.19449 9.84026 5.21739 9.78261 5.21739H5.21739V9.78261C5.21739 9.84026 5.19449 9.89556 5.15372 9.93633C5.11295 9.9771 5.05766 10 5 10C4.94234 10 4.88705 9.9771 4.84628 9.93633C4.80551 9.89556 4.78261 9.84026 4.78261 9.78261V5.21739H0.217391C0.159736 5.21739 0.104441 5.19449 0.0636725 5.15372C0.0229037 5.11295 0 5.05766 0 5C0 4.94234 0.0229037 4.88705 0.0636725 4.84628C0.104441 4.80551 0.159736 4.78261 0.217391 4.78261H4.78261V0.217391C4.78261 0.159736 4.80551 0.104441 4.84628 0.0636725C4.88705 0.0229037 4.94234 0 5 0C5.05766 0 5.11295 0.0229037 5.15372 0.0636725C5.19449 0.104441 5.21739 0.159736 5.21739 0.217391V4.78261H9.78261C9.84026 4.78261 9.89556 4.80551 9.93633 4.84628C9.9771 4.88705 10 4.94234 10 5Z"
        fill="#666666"
      />
    </svg>
  );
}

PlusIconNarrow.propTypes = {
  color: PropTypes.string,
};
